import { combineReducers } from 'redux'
import { currentTab, phoneNumbers } from './phone-numbers'

export default combineReducers({
    currentTab,
    phoneNumbers
})
